var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C12 7.34315 13.3431 6 15 6H34.7574C35.553 6 36.3161 6.31607 36.8787 6.87868L47.1213 17.1213C47.6839 17.6839 48 18.447 48 19.2426V51C48 52.6569 46.6569 54 45 54H15C13.3431 54 12 52.6569 12 51V9Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7426 19.5C47.8848 19.5 48 19.3848 48 19.2426C48 18.447 47.6839 17.6839 47.1213 17.1213L36.8787 6.87868C36.3161 6.31607 35.553 6 34.7574 6C34.6152 6 34.5 6.11522 34.5 6.25736V18.5C34.5 19.0523 34.9477 19.5 35.5 19.5H47.7426Z",
    fill: "#A8A8A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0826 31.2632L28.2285 58.2705C26.799 60.8697 28.6794 64.05 31.6458 64.05H61.3539C64.3202 64.05 66.2007 60.8697 64.7711 58.2705L49.9171 31.2632C48.4354 28.5692 44.5643 28.5692 43.0826 31.2632Z",
    fill: "#A8A8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 40.65C47.577 40.65 48.45 41.523 48.45 42.6V50.4C48.45 51.477 47.577 52.35 46.5 52.35C45.4231 52.35 44.55 51.477 44.55 50.4V42.6C44.55 41.523 45.4231 40.65 46.5 40.65Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 58.2C47.577 58.2 48.45 57.327 48.45 56.25C48.45 55.173 47.577 54.3 46.5 54.3C45.4231 54.3 44.55 55.173 44.55 56.25C44.55 57.327 45.4231 58.2 46.5 58.2Z",
    fill: "#F9F9F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.f07b211f57dfaf59c7dc1269e95668b9.svg";
export { ForwardRef as ReactComponent };